var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSetupRack = function SvgSetupRack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 15.875c.314 0 .574.231.618.533l.007.092v1a2.627 2.627 0 0 1-2.46 2.62l-.165.005H5a2.627 2.627 0 0 1-2.62-2.46l-.005-.165v-1a.625.625 0 0 1 1.243-.092l.007.092v1c0 .714.546 1.301 1.243 1.369l.132.006h12c.714 0 1.301-.546 1.369-1.243l.006-.132v-1c0-.345.28-.625.625-.625zm0-6c.314 0 .574.231.618.533l.007.092v1a2.627 2.627 0 0 1-2.46 2.62l-.165.005H5a2.627 2.627 0 0 1-2.62-2.46l-.005-.165v-1a.625.625 0 0 1 1.243-.092l.007.092v1c0 .714.546 1.301 1.243 1.369l.132.006h12c.714 0 1.301-.546 1.369-1.243l.006-.132v-1c0-.345.28-.625.625-.625zM16.164 2.5c.338 0 .617.254.658.583l.005.084v4.446a.665.665 0 0 1-.663.667.665.665 0 0 1-.659-.583l-.005-.084V3.167c0-.368.297-.667.664-.667zm2.655 1.779c.338 0 .617.254.658.583l.005.083v2.668a.665.665 0 0 1-.663.667.665.665 0 0 1-.659-.583l-.005-.084V4.945c0-.368.297-.666.664-.666zM13 3.875c.314 0 .574.231.618.533l.007.092v1a2.627 2.627 0 0 1-2.46 2.62L11 8.125H5a2.627 2.627 0 0 1-2.62-2.46L2.375 5.5v-1a.625.625 0 0 1 1.243-.092l.007.092v1c0 .714.546 1.301 1.243 1.369L5 6.875h6c.714 0 1.301-.546 1.369-1.243l.006-.132v-1c0-.345.28-.625.625-.625z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgSetupRack;